export const getColorByDensity = (density, maxDensity, totalSpots) => {
    if (density <= 1) return "#90EE90"; // Light green

    const normalizedDensity = Math.max(0, density - 1);
    const normalizedMax = Math.max(1, maxDensity - 1);
    
    // Baseline required to be considered a maximum density hotspot
    // E.g., at least 5 incidents, or 5% of all points
    const baselineMax = Math.max(20, Math.ceil(totalSpots * 0.20));
    const effectiveMax = Math.max(normalizedMax, baselineMax);

    const ratio = Math.min(normalizedDensity / effectiveMax, 1);

    if (ratio < 0.25) return "#90EE90"; // Light green
    if (ratio < 0.50) return "#FFD700"; // Yellow
    if (ratio < 0.75) return "#FF8C00"; // Orange
    if (ratio < 0.95) return "#FF6347"; // Tomato
    return "#DC143C"; // Crimson red
};